export default __webpack_public_path__ + "static/media/gallery_14.6c075594.jpg";